<div class="login-box">
  <div class="card card-outline card-primary">
    <div class="card-header text-center">
      <router-link to="/" class="h1">
        <b>HIAE</b> TRAUMA
      </router-link>
    </div>
    <div class="card-body">
      <p class="login-box-msg">Informe login e senha para entrar</p>

      <form @submit.prevent="login">
        <app-input
          class="mb-3"
          autocomplete="off"
          v-model="accessKey"
          placeholder="Login"
        />
        <app-input
          icon="lock"
          class="mb-3"
          type="password"
          placeholder="Senha"
          autocomplete="off"
          v-model="secretKey"
        />

        <div class="row">
          <div class="col-12">
            <app-button
              class="btn-primary"
              type="submit"
              block="true"
              :loading="isAuthLoading"
            >
            Entrar
            </app-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
